<template>
  <v-layout row wrap>
    <v-flex xs12 md6 lg4 class="pl-2 pr-2">
      <v-card class="card1" height="80" color="amber" width="220">
        <v-container fill-height>
          <v-icon color="#35455c" large>fas fa-car</v-icon>
          <span class="font-weight-light ml-3 title" style="color: #35455c">Conveyance</span>
        </v-container>
      </v-card>
      <v-card class="card2 mr-2 ml-2 pl-2 pr-2 pb-1" style="padding-top: 80px;" color="#35455c">
        <v-layout class="ml-3 mr-3 mb-3">
          <span
            class="subheading font-weight-light amber--text font-italic"
            style="text-align: justify"
          >Find and connect with students who would want share a ride with you. Add your travel details or just request someone to tag along!</span>
        </v-layout>
        
        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/post"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-address-card</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;My Posts</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >Create and manage your posts, and accept and reject requests with one click.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/search"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-search</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;Search</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >View all posts, or simply search for posts that are relevant to you.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/myrequest"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-share</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;My Requests</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >Track all your requests in one place and see the status for each of them.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-card>
    </v-flex>

    <v-flex xs12 md6 lg4 class="pl-2 pr-2">
      <v-card class="card1" height="80" color="amber" width="220">
        <v-container fill-height>
          <v-icon color="#35455c">fas fa-store</v-icon>
          <span class="font-weight-light ml-3 title" style="color: #35455c">Buy-And-Sell</span>
        </v-container>
      </v-card>
      <v-card class="card2 mr-2 ml-2 pl-2 pr-2 pb-1" style="padding-top: 80px;" color="#35455c">
        <v-layout class="ml-3 mr-3 mb-3">
          <span
            class="subheading font-weight-light amber--text font-italic"
            style="text-align: justify"
          >Connect with people around the campus, find things you want to buy, and add items that you would like to sell. Bid on items with your buying price.</span>
        </v-layout>
        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/buy"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-shopping-cart</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;Buy</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >View all items that you can buy or just sort by categories to find what you want.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/sell"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-money-check-alt</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;Sell</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >Add and manage items you want to sell, and view and accept all bids on them.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/mybids"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-comments-dollar</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;My Bids</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >View all the items on which you have bid and see the status of each of them.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-card>
    </v-flex>

    <v-flex xs12 md6 lg4 class="pl-2 pr-2">
      <v-card class="card1" height="80" color="amber" width="220">
        <v-container fill-height>
          <v-icon color="#35455c" large>timeline</v-icon>
          <span class="font-weight-light ml-3 title" style="color: #35455c">Future</span>
        </v-container>
      </v-card>
      <v-card class="card2 mr-2 ml-2 pl-2 pr-2 pb-1" style="padding-top: 80px;" color="#35455c">
        <v-layout class="ml-3 mr-3 mb-3">
          <span
            class="subheading font-weight-light amber--text font-italic"
            style="text-align: justify"
          >We want   to expand this small venture into a full-fledged portal for the entire campus. A one-stop-shop for all campus related activities. We plan on adding many components in future.</span>
        </v-layout>
        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/future"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-newspaper</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;Clubs Feed</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >Follow campus clubs of your choice and see all your updates in the same place.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/future"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-quote-right</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;Chat</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >Inbuilt chat features that spans all the previous and new components.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card
          flat
          color="rgba(0,0,0,0.2)"
          class="amber--text mb-1"
          style="border-radius: 10px"
          route
          to="/home/future"
        >
          <v-layout row wrap>
            <v-flex lg4>
              <v-container fill-height fluid style="padding-right: 0px; width:100%;">
                <v-icon color="amber">fas fa-bullhorn</v-icon>
                <span class="title font-weight-light stopflow">&nbsp;&nbsp;Lost/Found</span>
              </v-container>
            </v-flex>
            <v-flex lg8>
              <v-container fill-height>
                <span
                  class="font-italic"
                >A common place to share details of lost objects to help students find them easily.</span>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {};
</script>


<style scoped>
.card1 {
  border-radius: 10px;
  z-index: 1;
  left: 20px;
  top: 35px;
}
.card2 {
  border-radius: 10px;
  bottom: 20px;
}
.card3 {
  top: 70px;
}
.stopflow {
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}

</style>